import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import EventCard from '../EventCard';
import EventsFilter from '../Filter';
import { useLocation } from 'react-router-dom';
import { useFeaturedRotation } from '../../../hooks/useFeaturedRotation';

const List = ({ events, eventsPath, featuredId }) => {
  const location = useLocation();
  const isPrivateEvent = location.pathname.startsWith('/members');
  const { currentFeatured, remainingEvents } = useFeaturedRotation(events);

  return (
    <div className="lg:container mx-auto px-6 sm:mb-10 max-w-full">
      <EventsFilter />
      {!isEmpty(remainingEvents) || currentFeatured ? (
        <div className={`sm:grid gap-10 ${isPrivateEvent ? 'sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3' : 'sm:grid-cols-2 lg:grid-cols-3'}`}>
          {currentFeatured && (
            <EventCard events={currentFeatured} eventsPath={eventsPath} />
          )}
          {remainingEvents.map((item) => (
            <React.Fragment key={item.id}>
              <EventCard events={item} eventsPath={eventsPath} />
            </React.Fragment>
          ))}
        </div>
      ) : (
        !currentFeatured && <div className="p-10 text-center my-24">No events found</div>
      )}
    </div>
  );
};

List.propTypes = {
  events: PropTypes.array.isRequired,
  eventsPath: PropTypes.string,
  featuredId: PropTypes.string.isRequired,
};

List.defaultProps = {
  eventsPath: '/events',
};

export default List;
